import { render, staticRenderFns } from "./AddAdult.vue?vue&type=template&id=24f79ea5&scoped=true&lang=pug"
import script from "./AddAdult.vue?vue&type=script&lang=js"
export * from "./AddAdult.vue?vue&type=script&lang=js"
import style0 from "./AddAdult.vue?vue&type=style&index=0&id=24f79ea5&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f79ea5",
  null
  
)

export default component.exports